/*
Notes:我的保理Api接口
PS：
Author:Hgwn
Date:2018/9/4
*/
import ajax from './ajax';

export default {
    getMyBlItemInfoCount:function(params){ //获取用户看板数据
        return ajax.get('/loanform/blitem/blLoanItemFrontApply/getMyBlItemInfoCountNew.ht',params); // 9/12
    },
  getItemApplyList:function(params){
    return ajax.get('/loanform/blitem/blLoanItemFrontApply/getItemApplyListNew.ht',params); // 9/12
  },

  delFrontItem:function(params){
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/delFrontItem.ht',params);
  },

  getItemDetails:function (params) { //项目详情接口
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/getItemDetails.ht',params);
  },
  getPoolItemDetails:function (params) { //项目详情接口
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/getPoolItemDetails.ht',params);
  },  
  getRepayList:function (params) { //项目详情还款计划接口
    return ajax.postForm('/loanform/blfinance/blLoanItemFinanceRepay/getRepayList.ht',params);
  },
  getRepayDetails:function (parmas) { //还款计划详情
    return ajax.postForm('/loanform/blfinance/blLoanItemFinanceRepay/getRepayDetails.ht',parmas)
  },
  getFrontVoucherInfoList:function (params) { //凭证列表接口
    return ajax.postForm('/loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoList.ht',params);
  },
  getFrontVoucherInfoDetails:function (params) { //凭证详情
    return ajax.postForm('/loanform/blitem/blLoanAccountVoucherInfo/getFrontVoucherInfoDetails.ht',params);
  },
  //项目删除接口
  delFrontItem:function(params){
    return ajax.postForm('/loanform/blitem/blLoanItemFrontApply/delFrontItem.ht',params);
  },
  showContract:function (params) {// 下载电子合同
    return ajax.postForm('/mobile/item/pdfSignatureController/blReadContract.ht',params)
  },
  signContract:function(params){ //电子合同签名 --待对接 2018/9/21
    return ajax.postForm('/mobile/item/shortcutSignature/pdfSignatureCustomerBL.ht',params)
  },
  getCanPayMoney:function(params){//获取可融资申请金额-送货融资
    return ajax.get('/loanform/blfinance/blLoanPayApply/getCanPayMoney.ht',params);
  },
  applyLending:function(params){ //提交融资放款申请-送货融资
    return ajax.postForm('/loanform/blfinance/blLoanPayApply/applyLending.ht',params)
  }, 
  loanPayApplyList:function(params){//获取融资申请列表-送货融资
    return ajax.get('/loanform/blfinance/blLoanPayApply/loanPayApplyList.ht',params);
  },   
  getCanPayMoneyByBuyerIdForPool:function(params){//根据买方id获取可融资申请金额
    return ajax.get('/loanform/blfinance/blLoanPayApply/getCanPayMoneyByBuyerIdForPool.ht',params);
  }
};



// WEBPACK FOOTER //
// ./src/api/myloan_bl.js